import React from 'react'

const Instagram = function instagram ({info}){
    return (
    <div>
        <a href={https+"shop"} className="goToStore flex relative">
            <p>Ver Tienda </p>
            <img src={https+"img/menu/shop2.jpg"} alt="image-store"/>
        </a>
        <a href={https+"contact"} className="goToContact flex relative">
            <p>Contacto</p>
            <img src={https+"img/menu/contact2.jpg"} alt="image-contact"/>
        </a>

        <section className="instagram dnone">
            <h2>Instagram</h2>
            <div className="container w90 colflex">
            <div className="instagramImages flex">
            </div>
            <div className="toInstagram flex">
                <a href={info.instagram} target="_blank" >Ir a instagram</a>
            </div>
            </div>
        </section>
    </div>
)
}

export default Instagram